import { render } from "./Facturacion.vue?vue&type=template&id=57e0c33c&scoped=true"
import script from "./Facturacion.vue?vue&type=script&lang=js"
export * from "./Facturacion.vue?vue&type=script&lang=js"

import "./Facturacion.vue?vue&type=style&index=0&id=57e0c33c&scoped=true&lang=css"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-57e0c33c"]])

export default __exports__